import { useContext, useEffect } from "react";
import { AuthContext } from "../store/auth-context";
import { useSelector } from "react-redux";
import { Actions } from "../redux/constants/actionTypes";
import { getStore } from "../Utils/storeUtils";
import { Route, Routes, useLocation } from "react-router-dom";
import NewAuth from "../Layouts/Auth/NewAuth";

import { useNavigate } from "react-router-dom";
import NewLogin from "../Features/Authentication/Pages/Login/NewLogin";
import NewPlanSignup from "../Features/Authentication/Pages/NewPlanSignup/NewPlanSignup";
import NewPlanSignupLayout from "../Layouts/NewPlanSignupLayout/NewPlanSignupLayout";
import { Fingerprint, PersonAdd, Widgets } from "@mui/icons-material";
import NewSignup from "../Features/Authentication/Pages/Signup/NewSignup";
import NewForgot from "../Features/Authentication/Pages/Forgot/NewForgot";
import NewReset from "../Features/Authentication/Pages/Reset/NewReset";

const publicRoutesrenderList = [
  {
    path: "/new-signup",
    name: "New Signup",
    icon: PersonAdd,
    component: NewPlanSignup,
    layout: NewPlanSignupLayout,
  },
  {
    path: "/register",
    name: "Register",
    icon: PersonAdd,
    component: NewSignup,
    layout: NewAuth,
  },
  {
    path: "/login",
    name: "Login",
    icon: Fingerprint,
    component: NewLogin,
    layout: NewAuth,
  },
  {
    path: "/forgot",
    name: "forgot",
    icon: Widgets,
    component: NewForgot,
    layout: NewAuth,
    redirect: true,
  },
  {
    path: "/verify",
    name: "verify",
    icon: Widgets,
    component: NewReset,
    layout: NewAuth,
    redirect: true,
  },
];
const PublicRoutes = () => {
  const authCtx = useContext(AuthContext);
  let loggedInUserInfo = useSelector((state) => state.users.userInfo);

  const navigate = useNavigate();

  const currentUserDetails = authCtx.currentUser;

  if (!loggedInUserInfo && currentUserDetails) {
    let sessionUser = currentUserDetails?.tokens?.idToken?.payload;
    getStore().dispatch({
      type: Actions.LOGIN_USER,
      userInfo: sessionUser ? sessionUser : null,
    });
  }
  const currentUser = authCtx.isLoggedIn();

  const location = useLocation();

  useEffect(() => {
    let redirect = false;

    publicRoutesrenderList.map((route) => {
      if (route.path === location.pathname) {
        redirect = true;
      }
    });
    if (location.pathname === "/login") {
      redirect = true;
    }
    if (location.pathname === "/") {
      redirect = true;
    }
    if (location.pathname === "/" && !currentUser) {
      navigate("/login");
    } else if (currentUser && redirect) {
      navigate("/account/start");
    }
  }, []);

  // Google Tag Setup for page_view
  useEffect(() => {
    window.dataLayer.push({
      event: "page_view",
      page: {
        url: location.pathname,
        title: document.title,
      },
    });
  }, [location.pathname]);

  const getRoutes = () => {
    return (
      <Routes>
        {/* <Route path="/login" element={<NewAuth component={NewLogin} />} /> */}
        {publicRoutesrenderList.map((value, index) => {
          return (
            <Route
              key={index}
              path={value.path}
              element={<value.layout component={value.component} />}
            />
          );
        })}
      </Routes>
    );
  };

  return <>{getRoutes()}</>;
};

export default PublicRoutes;
